// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ChangeCustomerModalState from "@store/Framework/Store/Greif/Components/ChangeCustomerModal/ChangeCustomerModalState";
import { Draft } from "immer";

const initialState: ChangeCustomerModalState = {
    isOpen: false,
};

const actions = {
    "Greif/Components/ChangeCustomerModal/SetIsOpen": (
        draft: Draft<ChangeCustomerModalState>,
        action: { isOpen: boolean },
    ) => {
        draft.isOpen = action.isOpen;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type GreifComponentsChangeCustomerModalActions = Parameters<typeof reducer>[1];
export default reducer;
